const borderColor = (customValidationErrors, validationErrors, touched, theme) => {
  const { inputBorder, inputBorderError } = theme.colors;
  const errors = validationErrors ? Object.keys(validationErrors) : [];
  return (customValidationErrors || errors.length > 0) && touched ? inputBorderError : inputBorder;
};

const borderColorHover = (customValidationErrors, validationErrors, touched, theme) => {
  const { inputBorderHover, inputBorderError } = theme.colors;
  return (customValidationErrors || (validationErrors && validationErrors.length > 0)) && touched
    ? inputBorderError
    : inputBorderHover;
};

const borderMixin = ({ customValidationErrors, validationErrors, touched, theme, view, readOnly }) => {
  if (view || readOnly) {
    return `
      border: none;
    `;
  }
  return `
    border-radius: 0;
    border: none;
    border-bottom: 1px solid ${borderColor(customValidationErrors, validationErrors, touched, theme)};

    &:focus {
      border: none;
      border-bottom: 1px solid ${borderColorHover(customValidationErrors, validationErrors, touched, theme)};
      box-shadow: 0 1px 0 0 ${borderColorHover(customValidationErrors, validationErrors, touched, theme)};
      outline: 0;
    }

    &:disabled {
      border-bottom: 1px solid transparent;
    }
  `;
};

export default borderMixin;
